<template>
  <div class="fix-bar">
    <div
      class="customer-service"
      data-element-content="在线客服"
      @click="handleCustomerServiceClick"
    >
      <span class="fix-bar-text">在线咨询</span>
    </div>
    <div
      class="customer-service-phone"
      @mouseenter="handleServicePhoneEnter"
      @mouseleave="handleServicePhoneLeave"
    >
      <span class="fix-bar-text">客服热线</span>
    </div>
    <div
      class="official-account"
      @mouseenter="handleOfficalAccountEnter"
      @mouseleave="handleOfficalAccountLeave"
    >
      <span class="fix-bar-text">公众号</span>
    </div>
    <div class="up-to-top" @click="upToTop"></div>
    <!-- 客服热线 popup  -->
    <div
      class="service-phone-popup"
      :class="{ show: phonePopupShow, animate: phonePopupAnimate }"
    >
      <span class="service-phone-num">4006161023</span>
    </div>
    <!-- 公众号 popup -->
    <div
      class="official-account-popup"
      :class="{ show: accountPopupShow, animate: accountPopupAnimate }"
    >
      <div class="official-account-qrcode"></div>
      <div class="official-account-tips">扫描二维码</div>
      <div class="official-account-desc">关注咕比美术AI课公众号</div>
    </div>
  </div>
</template>

<script>
import config from '../../../config'
import { isAd, convertRouteNameToTitle } from '../../util'
// import I61Im from '@i61/i61-kefu-im'

export default {
  name: 'Fixbar',
  data() {
    return {
      accountPopupShow: false,
      accountPopupAnimate: false,
      phonePopupShow: false,
      phonePopupAnimate: false,
    }
  },
  async created() {
    if (isAd) {
      const { default: sensors } = await import('sa-sdk-javascript')
      this.sensors = sensors
    }
  },
  // created() {
  //   // 实例化客服
  //   const im = new I61Im()
  //   im.init({
  //     showBtn: false,
  //     accessId: config.kefu.accessId,
  //   })
  // },
  async mounted() {
    // 异步加载客服模块
    // 注意：该 npm 包不支持 ie 11 ！！
    import('@i61/i61-kefu-im').then(({ default: I61Im }) => {
      // 实例化客服
      const im = new I61Im()
      im.init({
        showBtn: false,
        accessId: config.kefu.accessId,
      })
    })
  },
  methods: {
    upToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    sendSensors(content) {
      if (isAd) {
        // 若果是推广页，则需要上报神策
        this.sensors.track('$WebClick', {
          $title: convertRouteNameToTitle(this.$route.name),
          $element_content: content,
        })
      }
    },
    handleCustomerServiceClick(e) {
      // 容联的sdk，会往windows中添加全局方法
      window.qimoChatClick && window.qimoChatClick()
      // 若果是推广页，则上报神策
      this.sendSensors(e.target.dataset.elementContent)
    },
    handleOfficalAccountEnter() {
      this.accountPopupShow = true
      setTimeout(() => {
        this.accountPopupAnimate = true
      }, 100)
    },
    handleOfficalAccountLeave() {
      this.accountPopupAnimate = false
      setTimeout(() => {
        this.accountPopupShow = false
      }, 100)
    },
    handleServicePhoneEnter() {
      this.phonePopupShow = true
      setTimeout(() => {
        this.phonePopupAnimate = true
      }, 100)
    },
    handleServicePhoneLeave() {
      this.phonePopupAnimate = false
      setTimeout(() => {
        this.phonePopupShow = false
      }, 100)
    },
  },
}
</script>

<style lang="scss">
@import './index.scss';
</style>
